import { render, staticRenderFns } from "./OrderDetailsModal.vue?vue&type=template&id=740c37e0"
import script from "./OrderDetailsModal.vue?vue&type=script&lang=js"
export * from "./OrderDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailsModal.vue?vue&type=style&index=0&id=740c37e0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports